
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/disabledAndShow/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-disabled-and-show-demo-disabled","pages-pages-reference-disabled-and-show-demo-columndisabledandshow","pages-pages-reference-disabled-and-show-demo-fielddisabledandshow"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/disabledAndShow/index.md?type=demo')
};